//
import GBranchOfficeModel from '@/models/General/GBranchOffice'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
  {
    name: 'g_branch_office_id',
    type: 'autocomplete-model',
    props: {
      label: 'Sucursal',
      model: GBranchOfficeModel,
      itemText: 'name',
      itemValue: 'id',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'init_date',
    type: 'date-field',
    props: {
      label: 'Fecha de Inicio',
      rules: [RequiredRule],
    },
  },
  {
    name: 'end_date',
    type: 'date-field',
    props: {
      label: 'Fecha de Término',
      rules: [RequiredRule],
    },
  },
]
